"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.POLLING_INTERVALS_MILLIS = void 0;
exports.POLLING_INTERVALS_MILLIS = {
    HVAC: 30 * 1000,
    // Power monitor CT readings are emitted ~30s; matching the sensor cadence keeps the UI
    // fresh without wasted GraphQL traffic.
    ELECTRICAL: 30 * 1000,
};
